// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";
import type { WellbeingServicesState } from "./types";

export type ShowAddModalRequest = $Exact<{
  show: boolean,
  step?: number,
}>;

const startRequest = beginRequest(["requestsInProgress"]);
const finishRequest = completeRequest(["requestsInProgress"]);

export const setLoading = (state: WellbeingServicesState) => () => startRequest(state);
export const setLoaded = (state: WellbeingServicesState) => () => finishRequest(state);
export const onError = (state: WellbeingServicesState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

export const onGetWellbeingServicesListSuccess = (state: WellbeingServicesState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetWellbeingServicesListError = (state: WellbeingServicesState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetWellbeingServiceDetailsSuccess = (state: WellbeingServicesState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onSetWellbeingServiceSchema = (state: WellbeingServicesState) => ({
  payload,
}: Object) => ({
  ...state,
  schema: payload,
});

// Create

export const onSetWellbeingServiceDraft = (state: WellbeingServicesState) => (
  action: Action<void>,
) => ({
  ...state,
  // if "action.payload" is undefined, use the default values
  draft:
    action.payload !== undefined
      ? action.payload
      : {
          name: null,
          phoneNumber: null,
          webSite: null,
          annualSpend: null,
          userName: null,
          password: null,
          aboutTheService: null,
          howToAccess: null,
          isPublic: null,
          activeFrom: null,
          activeTo: null,
          isActive: null,
          wellbeingProviderDto: null,
          wellbeingServiceTypes: [],
        },
});

export const onSetWellbeingServiceCurrentDetails = (state: WellbeingServicesState) => (
  action: Action<void>,
) => ({
  ...state,
  // if "action.payload" is undefined, use the default values
  current: action.payload !== undefined ? action.payload : null,
});

export const onNewWellbeingServiceAssignments = (state: WellbeingServicesState) => (
  action: Action<void>,
) => ({
  ...state,
  assignments: [],
});

export const setWellbeingServiceAssignments = (state: WellbeingServicesState) => ({
  payload,
}: Object) => ({
  ...state,
  assignments: payload,
});

export const onSetWellbeingServiceDraftAssignments = (state: WellbeingServicesState) => ({
  payload,
}: Object) => ({
  ...state,
  draftAssignments: payload,
});

// Modals

export const onSetShowAddWellbeingServiceModal = (state: WellbeingServicesState) => ({
  payload,
}: Action<ShowAddModalRequest>) => {
  if (!payload) {
    return state;
  }

  return {
    ...state,
    modals: {
      ...state.modals,
      showAddModal: payload.show,
      modalStep: payload.step || state.modals.modalStep,
    },
  };
};

export const onSetShowEditWellbeingServiceModal = (state: WellbeingServicesState) => ({
  payload,
}: Action<ShowAddModalRequest>) => {
  if (!payload) {
    return state;
  }

  return {
    ...state,
    modals: {
      ...state.modals,
      showEditModal: payload.show,
      modalStep: payload.step || state.modals.modalStep,
    },
  };
};

export const onShowEditAssignmentsModal = (state: WellbeingServicesState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditAssignmentsModal: payload,
  },
});
